import { ViewStream } from 'spyne';
import { FullscreenNullViewTraits } from 'traits/ui/fullscreen-null-view-traits.js';

// Behaviour participant only: the one place the app touches the browser's
// Fullscreen API. Appended to null by AppContainer.
export class FullscreenNullView extends ViewStream {
  constructor(props = {}) {
    props.channels = ['CHANNEL_FULLSCREEN', 'CHANNEL_WINDOW'];
    props.traits = [FullscreenNullViewTraits];
    super(props);
  }

  addActionListeners() {
    return [
      ['CHANNEL_FULLSCREEN_ENTER_EVENT', 'fullscreenNullView$OnEnter'],
      ['CHANNEL_FULLSCREEN_EXIT_EVENT', 'fullscreenNullView$OnExit'],
      ['CHANNEL_WINDOW_FULLSCREENCHANGE_EVENT', 'fullscreenNullView$OnBrowserChange'],
    ];
  }
}
